import compact from "lodash/compact";
import type { ReactNode } from "react";
import React from "react";
import { TimeLineItem } from "./TimelineItem";

interface Props extends Record<string, any> {
	className?: string;
	size?: "sm" | "md" | undefined;
	faded?: boolean;
}

export class TimeLine extends React.PureComponent<Props> {
	public static Item = TimeLineItem;

	public render(): ReactNode {
		const { className, size, faded, children } = this.props;

		return (
			<div
				className={compact(["timeline", size && `timeline-${size}`, faded && "timeline-faded", className]).join(
					" ",
				)}
			>
				{children}
			</div>
		);
	}
}
